class AudioPlayer {
  constructor(element) {
    this.url = element.dataset.audio;
    this.title = element.dataset.title;
    this.slider = element.dataset.slider;
    if (this.url) {
      this.audio = new Audio(this.url);
      element.innerHTML = this.html();
      this.play = element.querySelector('.toggle-play');
      this.timeline = element.querySelector('.timeline');
      this.progress = element.querySelector('.progress');
      this.current = element.querySelector('.current');
      this.total = element.querySelector('.total');

      this.init();
      element.audioPlayerInstance = this;
    }
  }

  init() {
    this.initPlay();
    this.seek();
    this.progressBar();
    if(this.title) {
      this.time();
    }
  }

  html() {
    return `
      <span class="toggle-play">
          <span class="play"></span>
      </span>
      <div class="timeline">
          <div class="bar">
              <span class="progress" style="width: 0;">
                <span class="handle"></span>
              </span>
          </div>
          ${this.title ? `
            <div class="foot">
              <div class="time">
                <span class="current"></span> / <span class="total"></span>
              </div>
              <div class="cap">${this.title}</div>
            </div>
          ` : ''}
      </div>
    `;
  }

  initPlay() {
    this.play.addEventListener("click", (e) => {
      this.pauseOther();
      if (this.audio.paused) {
        this.play.classList.remove("play");
        this.play.classList.add("pause");
        this.audio.play();
        this.pauseSlider();
      } else {
        this.play.classList.remove("pause");
        this.play.classList.add("play");
        this.audio.pause();
        this.resumeSlider();
      }
    }, false);
    this.audio.addEventListener("ended", (e) => {
        this.play.classList.remove("pause");
        this.play.classList.add("play");
    }, false);
  }

  seek() {
    this.timeline.addEventListener("click", e => {
      const timelineWidth = window.getComputedStyle(this.timeline).width;
      const timeToSeek = e.offsetX / parseInt(timelineWidth, 10) * this.audio.duration;
      this.audio.currentTime = timeToSeek;
      }, false);
  }

  progressBar() {
    this.updateInterval = setInterval(() => {
      this.progress.style.width = this.audio.currentTime / this.audio.duration * 100 + "%";
    }, 100);
  }

  time() {
    this.audio.addEventListener('loadeddata', ()=> {
      this.total.textContent = this.getTime(this.audio.duration)
    })

    this.updateInterval = setInterval(() => {
      this.current.textContent = this.getTime(this.audio.currentTime)
    }, 500);
  }

  getTime(num) {
    let seconds = parseInt(num);
    let minutes = parseInt(seconds / 60);
    seconds -= minutes * 60;
    const hours = parseInt(minutes / 60);
    minutes -= hours * 60;
    if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
    return `${String(hours).padStart(2, 0)}:${minutes}:${String(
        seconds % 60
    ).padStart(2, 0)}`;
  }

  pauseOther() {
    const audioPlayers = document.querySelectorAll('[data-audio]');
    audioPlayers.forEach(audioElement => {
      const audioPlayerInstance = audioElement.audioPlayerInstance;
      if (audioPlayerInstance && audioPlayerInstance !== this && !audioPlayerInstance.audio.paused) {
        audioPlayerInstance.audio.pause();
        audioPlayerInstance.play.classList.remove("pause");
        audioPlayerInstance.play.classList.add("play");
      }
    });
  }

  pauseSlider() {
    if (this.slider) {
      const slider = document.querySelector(this.slider);
      if (slider && slider.swiper) {
        slider.swiper.autoplay.pause();
      }
    }
  }

  resumeSlider() {
    if (this.slider) {
      const slider = document.querySelector(this.slider);
      if (slider && slider.swiper) {
        slider.swiper.autoplay.resize();
      }
    }
  }
}

export default AudioPlayer;
